import { Numbering, Position } from '@wix/ambassador-seating-v1-seating-plan/types';
import { LabelsPosition, SeatingSequence } from '../interfaces';
export const getBackwardsCompatiblePlan = (plan) => ({
    ...plan,
    // @ts-expect-error
    default: undefined,
    sectors: [],
    // @ts-expect-error
    sections: plan.sectors.map(sector => ({
        ...sector,
        elements: sector.elements
            ? // @ts-expect-error
                sector.elements.map(el => ({
                    ...el,
                    sequencing: el.seqMetaData
                        ? {
                            ...el.seqMetaData,
                            labels: el.seqMetaData.seq,
                            reverseOrder: el.seqMetaData.reverse,
                        }
                        : undefined,
                }))
            : undefined,
    })),
});
export const getNumberingToSequence = (seatNumbering) => {
    const map = {
        [Numbering.ALPHABETICAL]: SeatingSequence.ALPHABETIC,
        [Numbering.NUMERIC]: SeatingSequence.NUMERIC,
        [Numbering.ODD_EVEN]: SeatingSequence.NUMERIC_EVEN_OR_ODD,
    };
    return map[seatNumbering] ?? undefined;
};
export const getSequenceToNumbering = (sequence) => {
    const map = {
        [SeatingSequence.ALPHABETIC]: Numbering.ALPHABETICAL,
        [SeatingSequence.NUMERIC]: Numbering.NUMERIC,
        [SeatingSequence.NUMERIC_EVEN_OR_ODD]: Numbering.ODD_EVEN,
    };
    return map[sequence] ?? Numbering.UNKNOWN_NUMBERING;
};
export const getLabelsPositionToPosition = (labelPosition) => {
    const map = {
        [LabelsPosition.LEFT]: Position.LEFT,
        [LabelsPosition.RIGHT]: Position.RIGHT,
        [LabelsPosition.BOTH]: Position.BOTH,
    };
    return map[labelPosition] ?? Position.UNKNOWN_POSITION;
};
//# sourceMappingURL=plan.js.map